import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const CTASection = () => {
  return (
    <section 
      data-testid="cta-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-[#1a365d] rounded-3xl overflow-hidden">
          {/* Background pattern */}
          <div className="absolute inset-0">
            <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2" />
          </div>
          
          <div className="relative px-8 py-16 md:px-16 md:py-20 text-center">
            <h2 
              data-testid="cta-title"
              className="font-['Manrope'] text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6"
            >
              Prêt à créer et transformer<br />vos visiteurs en clients ?
            </h2>
            <p className="text-base md:text-lg text-white/80 mb-10 max-w-2xl mx-auto">
              Contactez-nous pour un devis gratuit. Nous vous répondons sous 24h.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/tarifs#quote-form">
                <Button 
                  data-testid="cta-primary-btn"
                  className="bg-white text-[#1a365d] hover:bg-[#F0F0F0] rounded-full px-8 py-6 text-sm font-semibold transition-all hover:scale-105 shadow-lg w-full sm:w-auto"
                >
                  Demander un devis
                  <ArrowRight className="ml-2" size={18} />
                </Button>
              </Link>
              <Button 
                data-testid="cta-secondary-btn"
                variant="outline"
                className="border-white/30 text-white hover:bg-white/10 rounded-full px-8 py-6 text-sm font-medium transition-all w-full sm:w-auto"
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Nous contacter
              </Button>
            </div>
            
            {/* Trust indicators */}
            <div className="mt-12 flex flex-wrap items-center justify-center gap-6 text-white/60 text-sm">
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                Devis gratuit
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                Sans engagement
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                Réponse sous 24h
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
